<style src="../css/head.css"></style>
<template>
  <div>
    <Head-section></Head-section>
    <div class="container">
      <img src="../assets/downloadbg.jpg" class="img-fluid w-100" alt="Responsive image">
      <!-- <div class="row">
        <button type="button" class="btn btn-light col">All</button>
        <button type="button" class="btn btn-light col">Headband</button>
        <button type="button" class="btn btn-light col">In-ear</button>
        <button type="button" class="btn btn-light col">Sound</button>
        <button type="button" class="btn btn-light col">Others</button>
      </div>-->

      <div class="card text-center">
        <div class="card-header">
          <ul class="nav nav-tabs card-header-tabs">
            <li class="nav-item">
              <a
                class="nav-link text-dark"
                href="#"
                :class="{active:tp==''}"
                @click="getManual('',0)"
              >{{$t('message.All')}}</a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link text-dark"
                href="#"
                :class="{active:tp=='1'}"
                @click="getManual('1',0)"
              >{{$t('message.Headband')}}</a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link text-dark"
                href="#"
                :class="{active:tp=='2'}"
                @click="getManual('2',0)"
              >{{$t('message.In_ear')}}</a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link text-dark"
                href="#"
                :class="{active:tp=='3'}"
                @click="getManual('3',0)"
              >{{$t('message.Sound')}}</a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link text-dark"
                href="#"
                :class="{active:tp=='4'}"
                @click="getManual('4',0)"
              >{{$t('message.Others')}}</a>
            </li>
          </ul>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-sm-6 mt-3" v-for="item in items" :key="item.id">
              <a :href="item.filename" class="text-dark">
                <div class="card text-center">
                  <div class="card-body">
                    <!-- <h5 class="card-title">Special title treatment</h5> -->
                    <p class="card-text" style=" font-size: 10em;">
                      <i class="far fa-file-pdf"></i>
                    </p>
                    <p class="card-text">{{item.ename}}</p>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <nav aria-label="Page navigation example ">
        <ul class="pagination justify-content-center mt-3">
          <li class="page-item">
            <a class="page-link" href="#" @click="prePage()">{{$t('message.Previous')}}</a>
          </li>
          <!-- <li class="page-item" v-forv-for="(tt,idx) in total_pg" :key="tt" :class="{active:idx==pg}">
                <a class="page-link" href="#" @click="getForumLs(foruid,tt-1)">{{tt}}</a>
          </li>-->
          <li class="page-item" :class="{active:(page1-1)==pg}">
            <a class="page-link" href="#" @click="getManual(tp,page1-1)">{{page1}}</a>
          </li>
          <li class="page-item" :class="{active:(page2-1)==pg}" v-if="total>1">
            <a class="page-link" href="#" @click="getManual(tp,page2-1)">{{page2}}</a>
          </li>
          <li class="page-item" :class="{active:(page3-1)==pg}" v-if="total>2">
            <a class="page-link" href="#" @click="getManual(tp,page3-1)">{{page3}}</a>
          </li>
          <li class="page-item" :class="{active:(page4-1)==pg}" v-if="total>3">
            <a class="page-link" href="#" @click="getManual(tp,page4-1)">{{page4}}</a>
          </li>
          <li class="page-item" :class="{active:(page5-1)==pg}" v-if="total>4">
            <a class="page-link" href="#" @click="getManual(tp,page5-1)">{{page5}}</a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#" @click="nextPage()">{{$t('message.Next')}}</a>
          </li>
        </ul>
      </nav>
    </div>
    <Foot-section></Foot-section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import HeadSection from "./HeadSection.vue";
import FootSection from "./FootSection.vue";
export default {
  name: "Manual",
  components: { HeadSection, FootSection },
  metaInfo() {
    return {
       title: this.$t("message.Bluedio_Mall") + " | Instruction book",
       titleTemplate: "%s",
      meta: [
         {
          name: "keywords",
          content: "Instruction book",
        }
      ],
    };
  },
  data() {
    return {
      items: [],
      tp: "",
      total: 0,
      total_pg: 5,
      pg: 0,
      page1: 1,
      page2: 2,
      page3: 3,
      page4: 4,
      page5: 5
    };
  },
  computed: {
    ...mapGetters([
      "lan_array"
    ])
  },
  created() {
    this.getManual(this.tp, this.pg);
    let language = this.$route.params.language;
    if(this.$store.state.lan_array.indexOf(language) == -1){
      this.toHome();
    }
  },
  methods: {
    ...mapActions({
      getManual(dispatch, tp, pg) {
        let pgs = 20;
        this.pg = pg;
        this.tp = tp;
        if (pg == 0) this.total = 0;
        dispatch("getManual", { tp, pg, pgs }).then(data => {
          if (data.result) {
            this.total = Math.ceil(data.total / 20);
            if (this.total <= 5) {
              this.total_pg = this.total;
            }
            this.items = data.items;
          }
        });
      }
    }),
    nextPage() {
      if (this.pg + 1 >= this.total) return;

      if (this.pg < this.page5 - 1) {
        this.getManual(this.tp, this.pg + 1);
      } else {
        this.page1 = this.page1 + 5;
        this.page2 = this.page2 + 5;
        this.page3 = this.page3 + 5;
        this.page4 = this.page4 + 5;
        this.page5 = this.page5 + 5;
        this.getManual(this.tp, this.pg + 1);
      }
    },
    prePage() {
      if (this.pg <= 0) return;

      if (this.pg < this.page1 - 1) {
        this.getManual(this.tp, this.pg - 1);
      } else {
        this.page1 = this.page1 - 5;
        this.page2 = this.page2 - 5;
        this.page3 = this.page3 - 5;
        this.page4 = this.page4 - 5;
        this.page5 = this.page5 - 5;
        this.getManual(this.tp, this.pg - 1);
      }
    },
    toHome() {
      let nameHome = this.lan + "home";
      this.$router.replace({
        name: nameHome
      });
    },
  }
};
</script>
